<template>
  <!-- TODO refactor this to something that is not a modal! -->
  <SModal
    v-model="show"
    class="modal-fullscreen modal-sdui"
    :style="`--right-alignment: ${scrollBarWidth}px`"
    size="xl"
    hide-backdrop
    static
    enforce-fade
    :scrollable="false"
    lazy
    force-hide-header
    hide-header-close
    hide-title
    hide-footer
    :prevent-focus-return-on-modal-close="preventFocusReturnOnModalClose"
  >
    <slot />
  </SModal>
</template>

<script>
export default {
  // TODO VUE3: Remove compatConfig when @vue/compat is removed
  compatConfig: {
    COMPONENT_V_MODEL: false,
  },

  name: 'MainMenu',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },

    preventFocusReturnOnModalClose: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    show: false,
    scrollBarWidth: 0,
  }),

  emits: ['update:modelValue'],

  methods: {
    // This class was shamelessly stolen from Bootstrap (node_modules/bootstrap-vue/src/components/modal/helpers/modal-manager.js).
    // It's used to get the scrollbar width which is needed
    // because the close button needs to be part of the modal itself (for a11y reasons).
    // But when a modal opens, it sets "overflow: hidden" on the body, which makes the scrollbar disappear.
    // This in turn moves the close button slightly to the right.
    // Note: Since bootstrap also relies on this logic, it should be safe to use. We gonna wrap it in try/catch
    // anyway, just to be sure.
    getScrollbarWidth() {
      try {
        const isBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined'
        const isElement = (el) => !!(el && el.nodeType === Node.ELEMENT_NODE)
        const addClass = (el, className) => {
          // We are checking for `el.classList` existence here since IE 11
          // returns `undefined` for some elements (e.g. SVG elements)
          // See https://github.com/bootstrap-vue/bootstrap-vue/issues/2713
          if (className && isElement(el) && el.classList) {
            el.classList.add(className)
          }
        }
        const getBCR = (el) => (isElement(el) ? el.getBoundingClientRect() : null)

        // Determine if the body element is overflowing
        const { left, right } = getBCR(document.body)
        const isBodyOverflowing = left + right < window.innerWidth

        if (!isBrowser() || !isBodyOverflowing) return 0

        // Create a temporary `div.measure-scrollbar` to get computed z-index
        const div = document.createElement('div')
        addClass(div, 'modal-scrollbar-measure')
        document.body.appendChild(div)
        const scrollbarWidth = getBCR(div).width - div.clientWidth
        document.body.removeChild(div)
        return scrollbarWidth || 0
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        return 0
      }
    },
  },

  watch: {
    show(newVal) {
      this.$emit('update:modelValue', newVal)
    },

    modelValue(newVal) {
      this.show = newVal
    },

    '$route.name'() {
      this.show = false
    },
  },

  beforeMount() {
    this.scrollBarWidth = this.getScrollbarWidth()
  },
}
</script>

<style lang="scss">
// unscoped styles for the modal, which is rendered on the body level
.modal-sdui .modal.fade {
  /*transform: translate(0, -50px) !important;*/
  transition: transform 0.1s ease-out !important;
  background-color: rgba($color-white-rgb, 0.91);
}

.modal-sdui .modal.show {
  transition: transform 0.1s ease-out !important;
  transform: none;
}

.modal-sdui .modal-dialog {
  position: fixed;
  bottom: 0; /*for older browsers where 'env' is not supported*/
  bottom: env(safe-area-inset-bottom);
  padding: 0 16px !important;
  margin: auto !important;
  width: 100%;
  max-width: 320px !important;
  min-width: initial !important;
  margin-bottom: 84px !important;
  left: 0;
  right: var(--right-alignment);
}

// revert some bootstrap styles for this specific modal
@media (max-width: 460px) {
  .modal-sdui .modal-dialog {
    height: auto !important;
    padding-top: 0 !important;
  }
}

.modal-sdui .btn-action {
  text-align: left;
}

/** Clickable content area: **/
.modal-sdui .modal-content {
  /*background-variant: green;*/
  width: auto;
  min-width: auto;
  margin: auto;
  max-width: 315px;
}

.modal-sdui .modal-content .btn-round {
  padding: 11px 8px;
  text-align: left !important;
}

.modal-sdui .modal-body {
  /*border: 1px solid red;*/
  width: auto;
  min-width: auto;
}
</style>
